import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=5133a870&scoped=true&"
import script from "./NewRegister.vue?vue&type=script&lang=js&"
export * from "./NewRegister.vue?vue&type=script&lang=js&"
import style0 from "./NewRegister.vue?vue&type=style&index=0&id=5133a870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133a870",
  null
  
)

export default component.exports